<template lang="pug">
div
	v-e24-nav-bar
	section.maincolumn-constrained
		.form-in-columns
			.side
				new-customer-form
			.side
				login-form(:goodbye="goodbye", :redirect="redirect")
	v-e24-footer(:build="build")
</template>

<script>
import loginForm from 'CommonApp/security/login-form.vue'
import newCustomerForm from './new-customer.vue'
import readBuild from '../../util/readBuild'

export default {
	name: 'Login',
	props: ['goodbye', 'redirect'],
	data () {
		return {
			build: ''
		}
	},
	components: { loginForm, newCustomerForm },
	methods: {},
	mixins: [readBuild],
	mounted () {
		this.build = this.getBuild()
	}
}
</script>



// WEBPACK FOOTER //
// src/app/login/login-component.vue